// extracted by mini-css-extract-plugin
export default {"container":"cookies-page-content-module--container--kJorv","options":"cookies-page-content-module--options--KnqJD","button":"cookies-page-content-module--button--hqhgc"};